import customTranslate from "../modelerTranslate/customTranslate";
function PopupMenuProvider(popupMenu, modeling) {
  this._popupMenu = popupMenu;
  this._modeling = modeling;

  this._popupMenu.registerProvider("color-picker", this);
}

PopupMenuProvider.$inject = ["popupMenu", "modeling"];
export default PopupMenuProvider;

PopupMenuProvider.prototype.getEntries = function (element) {
  const self = this;

  const colors = [
    {
      label: customTranslate("Red"),
      hex: "ff0000",
    },
    {
      label: customTranslate("Orange"),
      hex: "ff7f00",
    },
    {
      label: customTranslate("Yellow"),
      hex: "ffff00",
    },
    {
      label: customTranslate("Green"),
      hex: "00ff00",
    },
    {
      label: customTranslate("Blue"),
      hex: "0000ff",
    },
    {
      label: customTranslate("Indigo"),
      hex: "4b0082",
    },
    {
      label: customTranslate("Violet"),
      hex: "9400d3",
    },
  ];

  const entries = colors.map(function (color) {
    return {
      label: color.label,
      id: color.label.toLowerCase() + "-color",
      className: "color-icon-" + color.hex,
      action: createAction(self._modeling, element, "#" + color.hex),
    };
  });

  return entries;
};

PopupMenuProvider.prototype.getHeaderEntries = function (element) {
  return [
    {
      label: "Clear",
      id: "clear-color",
      className: "color-icon-clear",
      action: createAction(this._modeling, element),
    },
  ];
};

function createAction(modeling, element, newColor) {
  // set hex value to an element
  return function () {
    const ns = newColor
      ? "http://www.omg.org/spec/BPMN/non-normative/color/1.0"
      : undefined;

    modeling.updateProperties(element, {
      di: {
        "xmlns:color": ns,
        "color:background-color": newColor,
      },
    });
  };
}
